export default function formateMafreDate(date) {
  if (date) return date.split('-').reverse().join('/');
}
